export default __webpack_public_path__ + "images/icon-favicon.a23de6de3bc3a16774ec3412cd8c0dd6.svg";